(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-size-guide-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gp-size-guide')) {
  customElements.define('gp-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.guideReady) return;
      const prepare = () => {
        const template = this.querySelector(':scope > template');
        if (!template) return false;
        const category = this.dataset.guideCategory;
        const audience = this.dataset.guidePlayer;
        const categoryValid = ['chaussures', 'textile'].includes(category);
        const audienceValid = ['homme', 'femme', 'junior', 'all'].includes(audience);
        const matches = categoryValid && audienceValid
          ? [...template.content.querySelectorAll('section[data-size-category][data-size-audience]')].filter(section => {
              const sectionAudience = section.dataset.sizeAudience;
              return section.dataset.sizeCategory === category &&
                (audience === 'all'
                  ? ['homme', 'femme', 'all'].includes(sectionAudience)
                  : audience === 'junior'
                    ? sectionAudience === 'junior'
                    : sectionAudience === audience || sectionAudience === 'all') &&
                section.querySelector('table');
            })
          : [];
        const output = document.createDocumentFragment();
        matches.forEach(section => output.append(section.cloneNode(true)));
        if (matches.length) {
          const advice = template.content.querySelector('[data-size-advice]');
          if (advice && advice.dataset.sizeAdvice === category) {
            output.append(advice.cloneNode(true));
          }
        }
        this.replaceChildren(output);
        this.dataset.guideReady = 'true';
        this.hidden = matches.length === 0;
        if (!matches.length) {
          const modal = this.closest('x-modal');
          const picker = this.closest('variant-selects');
          if (modal && picker) {
            picker.querySelectorAll('[aria-controls]').forEach(trigger => {
              if (trigger.getAttribute('aria-controls') === modal.id && !modal.contains(trigger)) {
                trigger.hidden = true;
                trigger.style.display = 'none';
              }
            });
          }
        }
        return true;
      };
      if (!prepare()) {
        this.guideObserver = new MutationObserver(() => {
          if (prepare()) this.guideObserver.disconnect();
        });
        this.guideObserver.observe(this, { childList: true });
      }
    }
    disconnectedCallback() {
      if (this.guideObserver) this.guideObserver.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
